import { render, staticRenderFns } from "./ProjShareDetail.vue?vue&type=template&id=afbdf29a&scoped=true&"
import script from "./ProjShareDetail.vue?vue&type=script&lang=js&"
export * from "./ProjShareDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProjShareDetail.vue?vue&type=style&index=0&id=afbdf29a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbdf29a",
  null
  
)

export default component.exports